/**
 * Created by steven@coplex.com on 10/4/18.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import styles from './TemplatesTable.module.css';

const TemplatesTable = ({ onDeleteTemplate, onEditTemplate, templates }) => (
  <Table hover condensed className={styles.templatesTable}>
    <tbody>
      {templates.map((template) => (
        <tr key={template.id}>
          <td>
            <strong>{template.name}</strong>
          </td>
          <td>
            <Button target="_blank" href={template.url} bsStyle="primary">
              View
            </Button>
            &nbsp;&nbsp;
            {template.organizationId ? (
              <Button
                className="btn-edit"
                onClick={() => onEditTemplate(template.id)}
              >
                Edit
              </Button>
            ) : (
              <Button
                className="btn-delete"
                onClick={() => onDeleteTemplate(template.id)}
              >
                Delete
              </Button>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

TemplatesTable.propTypes = {
  onDeleteTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      organizationId: PropTypes.number,
    })
  ).isRequired,
};

export default TemplatesTable;
